// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student-account[data-v-3ef09610] {\n  font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
